const CheckboxBorderIcon = props => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M13.7809 2.29199H6.55677C4.03927 2.29199 2.46094 4.07449 2.46094 6.59699V13.4037C2.46094 15.9262 4.03177 17.7087 6.55677 17.7087H13.7801C16.3059 17.7087 17.8776 15.9262 17.8776 13.4037V6.59699C17.8776 4.07449 16.3059 2.29199 13.7809 2.29199Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default CheckboxBorderIcon;
